import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import SegmentWrapper from '@/views/process/components/quizInialized/SegmentWrapper.tsx';
import { FC } from 'react';

interface Props {
  handleNext: () => void;
  showSkip?: boolean;
}

const audioUrl = 'https://lets-orange.b-cdn.net/lektor-orange-2026/ORANGE_2.mp3';
const animationUrl = 'https://lets-orange.b-cdn.net/animacje/LOQ_S1_B_02.json';

const IntroSegment2: FC<Props> = ({ handleNext, showSkip = false }) => {
  const { t } = useTranslationWithPrefix('views.process.quizScenarios');

  return (
    <SegmentWrapper
      animationUrl={animationUrl}
      audioUrl={audioUrl}
      content={
        <>
          <p className="lead fw-bold ">{t('intro.segment2.title')}</p>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-s">
            <p className="lead">{t('intro.segment2.content')}</p>
          </div>
        </>
      }
      handleNext={handleNext}
      hasNext
      showSkip={showSkip}
    />
  );
};

export default IntroSegment2;
